import { get } from "lodash";

const isProduction =
  (process.env.REACT_APP_NODE_ENV || "").toLowerCase() === "production";

const featureFlags = {
  // Reward-points at checkout (earn preview + use-points discount). Enabled outside
  // production so it can be validated in sandbox before the production rollout.
  rewardPointsCheckout: !isProduction,
  updateOrderStatus: !isProduction,

  newClaimPayoutFlow: true,
};

export function getFeatureFlag(key) {
  return get(featureFlags, key, false);
}
